'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _reducers = require('./reducers');

var reducer = _interopRequireWildcard(_reducers);

var _localSelectors = require('./selectors/localSelectors');

var selectors = _interopRequireWildcard(_localSelectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: _components2.default,
  reducer: reducer,
  selectors: selectors
};


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/plugins/local/index.js
// module id = 1131
// module chunks = 0